
import React from 'react'
import css from './ReceiptFooter.module.css'

const ReceiptFooter = props => (
  <footer className={css.main}>
    <h2>Credit card statement</h2>
    <p>Your credit card will show a transaction from "{props.payment.statement || 'Segment'}".</p>
  </footer>
)

export default ReceiptFooter



// WEBPACK FOOTER //
// ./components/ReceiptFooter.js